import type { Branded } from '@client/new/helpers/types';

export type CommunityId = Branded<number, 'CommunityId'>;

export type Community = {
  id: CommunityId;
  name: string;
  description: string;
  thumbnail: string | null;
  membersCount: number;
  reportedPostsCount: number;
  blockedUsersCount: number;
};

export const toCommunityId = (value: number): CommunityId =>
  value as CommunityId;
